module.exports = __webpack_public_path__ + "media/images/products/about/megaphone-02e84fc54f3cf233aa9cd1a5e719ed05.png";